import { notification } from 'antd'

export class Notifications {
  static handle(error: Error) {
    notification.error({
      message: error.message,
    })
  }
}
